import { HistoryStore as BaseHistoryStore } from '@bn-games/history-core';
import type { GameRecord } from './types.js';
import { HISTORY_SCHEMA_VERSION } from './types.js';
import { normalizeRecordVariant } from './legacyVariant.js';

// Per-app subclass pre-configures @bn-games/history-core's generic FIFO list
// with domino's storage key + schema version + shape predicate. Callers
// continue to do `new HistoryStore()` without thinking about config.
export class HistoryStore extends BaseHistoryStore<GameRecord> {
  constructor() {
    super({
      storageKey: 'domino-history',
      schemaVersion: HISTORY_SCHEMA_VERSION,
      isValid: (parsed) => Array.isArray(parsed.moves),
    });
  }

  override list(): readonly GameRecord[] {
    return super.list().map(normalizeRecordVariant);
  }

  override get(id: string): GameRecord | null {
    const record = super.get(id);
    return record === null ? null : normalizeRecordVariant(record);
  }
}
